module.exports = __webpack_public_path__ + "static/media/crop-page-1.fe46b434.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Features/CropImages/assets/crop-page-1.jpg
// module id = 1294
// module chunks = 0